module.exports = __webpack_public_path__ + "img/pts.50b30cff.png";